import { NoticeType } from '@shared/config/notice'

export const getStatusText = (status: NoticeType) => {
  switch (status) {
    case NoticeType.SUCCESS: {
      return 'Платёж отправлен'
    }
    case NoticeType.ERROR: {
      return 'Платёж не отправлен'
    }
    default: {
      return 'Платеж принят в обработку'
    }
  }
}
